<template>
  <div>
    <div id="map" class="h-250"></div>
  </div>
</template>

<style scoped>
  #map {
    margin: 0 auto;
    background: gray;
  }

  .h-250 {
    /* height: 250px; */
    /* height: calc(100vh - 139px); */
  }
</style>
<script>  
  import Vue from 'vue';

  export default {
    name: "googleMaps",
    props: {
      'latitude': {
        type: Number,
        default() {
          return 0
        }
      },
      'longitude': {
        type: Number,
        default() {
          return 0
        }
      },
      'zoom': {
        type: Number,
        default() {
          return 20
        }
      },
    },
    mounted() {
      this.$markers = [];
      this.$latlngbounds = new google.maps.LatLngBounds();
      this.$map = new google.maps.Map(document.getElementById('map'), {
        center: new google.maps.LatLng(this.latitude, this.longitude),
        zoom: this.zoom,
        zIndex: this.zindex,
        // gestureHandling: 'none',
        // draggable: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        // disableDefaultUI: true
        mapTypeControl: false,
        fullscreenControl: false
      });
      this.$emit('getCoordinates');

      Vue.nextTick().then(() => {
        // this.clearMarkers();
      });
    },
    created() {
      let vm = this;
      vm.$store.state.bus.$on('clear-markers', () => {
        this.clearMarkers();
        this.$markers = [];
      });
      // removeMarkLatitudeAndLongitude
      vm.$store.state.bus.$on("removeMarkLatitudeAndLongitude", (data) => {
        var getmarker = new google.maps.Marker({
          position: { lat: data.latitude, lng: data.longitude },
        });

        for (var i = 0; i < this.$markers.length; i++) {         
          if (this.$markers[i].getPosition().equals(getmarker.getPosition())) {
            // console.log("this.$markers[i]", this.$markers[i], "in leave");
            this.$markers[i].setIcon("src/content/images/map-marker.png");
           
          }
        }
      });
      vm.$store.state.bus.$on("markLatitudeAndLongitude", (data) => {
        var getmarker = new google.maps.Marker({
          position: { lat: data.latitude, lng: data.longitude },
        });

        // "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"

        for (var i = 0; i < this.$markers.length; i++) {
          if (this.$markers[i].getPosition().equals(getmarker.getPosition())) {
            // console.log("this.$markers[i]", this.$markers[i], "in hover");
            
            this.$markers[i].setIcon("src/content/images/map-marker-h.png");
            this.$markers[i].setZIndex(this.zindex++);
            
          }
          else if(this.$markers[i].icon == "src/content/images/map-marker-h.png" && this.$markers[i].icon != "src/content/images/map-marker-d1.png"){
            this.$markers[i].setIcon("src/content/images/map-marker.png");           
          }
        }

      })
      vm.$store.state.bus.$on('add-marker', (data) => {
        console.log("data in map", data);
        vm.clearMarkers();
        var infowindow = new google.maps.InfoWindow();
        // var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        // var labelIndex = 0;


        var marker, i;
        var iconName = data.latitudeLongitude.length == 1 ? 'map-marker-star.png' : 'map-marker.png';

        for (i = 0; i < data.latitudeLongitude.length; i++) {
          let currZindex = this.zindex++
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(data.latitudeLongitude[i].latitude, data.latitudeLongitude[i].longitude),
            // label: labels[labelIndex++ % labels.length],
            label: {
              text: data.latitudeLongitude[i].Label,
              color: "white",
              fontSize: "16px", 
              fontWeight: "bold",
              zIndex: currZindex,
            },
            map: this.$map,
            icon: "src/content/images/"+iconName,
            zIndex: currZindex,
            

          });
          // this.$map.panTo(new google.maps.LatLng(data.latitudeLongitude[i].latitude, data.latitudeLongitude[i].longitude));
          google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
              // console.log("marker marker", marker);
              // console.log("here", data.latitudeLongitude[i].latitude, data.latitudeLongitude[i].longitude);
              // marker.setIcon("src/content/images/map-marker-h.png");
              if (data.latitudeLongitude.length > 1) {
                vm.markLabel({ latitude: data.latitudeLongitude[i].latitude, longitude: data.latitudeLongitude[i].longitude, label: data.latitudeLongitude[i].Label });
                marker.setZIndex(vm.zindex++);
                // zIndex = zIndex + 1;

                vm.$emit('filterProperties', { latitude: data.latitudeLongitude[i].latitude, longitude: data.latitudeLongitude[i].longitude, label: data.latitudeLongitude[i].Label });
              }
            }
          })(marker, i));
          this.$latlngbounds.extend(marker.position);
          this.$markers.push(marker);
        }

        for (i = 0; i < data.unavailableLatLong.length; i++) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(data.unavailableLatLong[i].latitude, data.unavailableLatLong[i].longitude),
            label: {
              text: data.unavailableLatLong[i].Label,
              color: "white",
              fontSize: "16px",
              fontWeight: "bold"             
            },
            map: this.$map,
            icon: "src/content/images/map-marker-d1.png"           
          });
          this.$latlngbounds.extend(marker.position);
          this.$markers.push(marker);
        }






        var styles = {
          default: null,
          hide: [
            {
              featureType: 'all',
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }]
            }
          ]
        };
        this.$map.setOptions({ minZoom: data.MinZoomValue, maxZoom: data.MaxZoomValue });
        this.$map.setCenter(this.$latlngbounds.getCenter());
        this.$map.fitBounds(this.$latlngbounds);
        this.$map.setOptions({ styles: styles['hide'] });






      });

      // boundries
      // vm.$store.state.bus.$on('add-markerBoundries', (data) => {
      //   console.log("data in map", data);
      //   vm.clearMarkers();
      //   var infowindow = new google.maps.InfoWindow();
       
      //   var marker, i;

      //   for (i = 0; i < data.latitudeLongitude.length; i++) {
      //     let currZindex = this.zindex++
      //     marker = new google.maps.Marker({
      //       position: new google.maps.LatLng(data.latitudeLongitude[i].latitude, data.latitudeLongitude[i].longitude),
            
      //       map: this.$map,
          
          
            

      //     });
      //     this.$latlngbounds.extend(marker.position);
      //     this.$markers.push(marker);
      //     marker.setVisible(false);
      //   }


      //   var styles = {
      //     default: null,
      //     hide: [
      //       {
      //         featureType: 'all',
      //         elementType: 'labels.icon',
      //         stylers: [{ visibility: 'off' }]
      //       }
      //     ]
      //   };
        
      //   this.$map.setCenter(this.$latlngbounds.getCenter());
      //   this.$map.fitBounds(this.$latlngbounds);
      //   this.$map.setOptions({ styles: styles['hide'] });






      // });
      // boundries
    },
    data() {
      return {
        zindex :1000,
      };
    },
    methods: {
      pinSymbol(color) {
        return {
          path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
          fillColor: color,
          fillOpacity: 1,
          strokeColor: '#000',
          strokeWeight: 1,
          scale: 1
        };
      },
      markLabel(params){
        var getmarker = new google.maps.Marker({
          position: { lat: params.latitude, lng: params.longitude },
        });

        // "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"

        for (var i = 0; i < this.$markers.length; i++) {
          if (this.$markers[i].getPosition().equals(getmarker.getPosition())) {
            // console.log("this.$markers[i]", this.$markers[i], "in hover");

            this.$markers[i].setIcon("src/content/images/map-marker-h.png");
           
          }
          else if(this.$markers[i].icon != "src/content/images/map-marker-d1.png"){
            this.$markers[i].setIcon("src/content/images/map-marker.png");
          }
        }
      },
      makeMarker(latitude, longitude, zoom) {
        // this.zoom = zoom;
        // var locationRio = {lat: -22.915, lng: -43.197};
        // var map = new google.maps.Map(document.getElementById('map'), {
        //   zoom: 13,
        //   center: locationRio,
        //   gestureHandling: 'cooperative'
        // });
        // console.log("zoom", zoom)
        this.$map = new google.maps.Map(document.getElementById('map'), {
          center: new google.maps.LatLng(latitude, longitude),
          zoom: zoom
        });
        return new google.maps.Marker({
          position: new google.maps.LatLng(latitude, longitude),
          icon: null,
          map: this.$map,
          title: null,
        });
      },
      clearMarkers() {
        for (let i = 0; i < this.$markers.length; i++) {
          this.$markers[i].setMap(null);
          this.$latlngbounds = new google.maps.LatLngBounds();
          // this.$emit('getCoordinates');
        }
      }
    }
  }
</script>


<!-- var map = new google.maps.Map(document.getElementById('map'), {
  zoom: minZoomLevel,
  center: new google.maps.LatLng(38.50, -90.50),
  mapTypeId: google.maps.MapTypeId.ROADMAP
});

// Bounds for North America
var strictBounds = new google.maps.LatLngBounds(
new google.maps.LatLng(28.70, -127.50),
// new google.maps.LatLng(48.85, -55.90)
);

// Listen for the dragend event
google.maps.event.addListener(map, 'dragend', function () {
  if (strictBounds.contains(map.getCenter())) return;

  // We're out of bounds - Move the map back within the bounds

  var c = map.getCenter(),
      x = c.lng(),
      y = c.lat(),
      maxX = strictBounds.getNorthEast().lng(),
      maxY = strictBounds.getNorthEast().lat(),
      minX = strictBounds.getSouthWest().lng(),
      minY = strictBounds.getSouthWest().lat();

  if (x < minX) x = minX;
  if (x > maxX) x = maxX;
  if (y < minY) y = minY;
  if (y > maxY) y = maxY;

  map.setCenter(new google.maps.LatLng(y, x));
});

// Limit the zoom level
google.maps.event.addListener(map, 'zoom_changed', function () {
  if (map.getZoom() < minZoomLevel) map.setZoom(minZoomLevel);
}); -->


// WEBPACK FOOTER //
// src/components/googleMapsComponent/googleMapsComponent.vue